import { render, staticRenderFns } from "./Arboles.vue?vue&type=template&id=0550d51d&scoped=true&"
import script from "./Arboles.vue?vue&type=script&lang=js&"
export * from "./Arboles.vue?vue&type=script&lang=js&"
import style0 from "./Arboles.vue?vue&type=style&index=0&id=0550d51d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0550d51d",
  null
  
)

export default component.exports